import { computed, defineComponent, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { FiscalYearGetter } from '@/store/fiscalYear/fiscalYear.module';
import { FiscalYear } from '@/store/fiscalYear/fiscalYear.model';
import { MinisterAction, MinisterGetter } from '@/store/minister/minister.module';
import { Minister } from '@/store/minister/minister.model';
import MinisterFilterComponent from '@/components/ministerFilter/MinisterFilter.vue';
import ProjectMinisterSummaryComponent from '@/components/project/main/projectMinisterSummary/ProjectMinisterSummary.vue';
import ResultResponseComponent from '@/components/resultResponse/ResultResponse.vue';
import ResultProjectTypeComponent from '@/components/resultProjectType/ResultProjectType.vue';

export default defineComponent({
  name: 'ResultMinisterPage',
  components: {
    MinisterFilterComponent,
    ProjectMinisterSummaryComponent,
    ResultResponseComponent,
    ResultProjectTypeComponent,
  },
  setup: () => {
    const store = useStore();
    const fiscalYear = computed<FiscalYear>(() => store.getters[FiscalYearGetter.BY_ID](fiscalYearId.value));
    const minister = computed<Minister>(() => store.getters[MinisterGetter.BY_ID](ministerId.value));
    const fiscalYearId = ref<number | null>();
    const ministerId = ref<number | null>();

    onMounted(() => {
      store.dispatch(MinisterAction.FETCH);
    });

    const filterChange = (filter: { fiscalYearId: number; ministerId: number }) => {
      fiscalYearId.value = filter.fiscalYearId;
      ministerId.value = filter.ministerId;
    };

    return {
      fiscalYear,
      minister,
      filterChange,
    };
  }
});
